import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-093b66e9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "frag-channel" }
const _hoisted_2 = { class: "viewport" }
const _hoisted_3 = { class: "column" }

import { t } from '@/plugins/i18n'
// const texts = ['青蛙频道', '更多最新文章'].map(t)
import HotArticles from '@/components/article/HotArticles.vue'
import { isD2C, useSite } from '@/store'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["banner", _unref(useSite)() + (_unref(isD2C)() ? '-d2c' : '-b2b')])
      }, null, 2),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(HotArticles, {
          title: "青蛙频道",
          size: 6,
          showEmpty: false,
          itemJumpWay: "1"
        })
      ])
    ])
  ]))
}
}

})